/**
 * 用户订阅状态工具函数
 */

import paymentAPI from '../services/paymentApi';

const subscriptionCache = new Map();
const SUBSCRIPTION_CACHE_TTL_MS = 30 * 1000;

/**
 * 获取用户订阅信息
 * @param {string} userId - 用户ID
 * @returns {Promise<Object>} 订阅信息
 */
export const getUserSubscription = async (userId) => {
  try {
    if (userId) {
      const cached = subscriptionCache.get(userId);
      if (cached && Date.now() - cached.timestamp < SUBSCRIPTION_CACHE_TTL_MS) {
        return cached.data;
      }
    }

    const result = await paymentAPI.getUserSubscription(userId);
    if (userId) {
      subscriptionCache.set(userId, { data: result, timestamp: Date.now() });
    }
    return result;
  } catch (error) {
    return {
      success: true,
      subscription: null,
      vip_level: 'L0',
      is_vip: false
    };
  }
};

/**
 * 检查用户是否为会员
 * @param {string} userId - 用户ID
 * @returns {Promise<boolean>} 是否为会员
 */
export const isVipUser = async (userId) => {
  try {
    const subscription = await getUserSubscription(userId);
    return subscription.is_vip || false;
  } catch (error) {
    return false;
  }
};

/**
 * 检查用户是否为体验版（非会员）
 * @param {string} userId - 用户ID
 * @returns {Promise<boolean>} 是否为体验版
 */
export const isTrialUser = async (userId) => {
  try {
    const subscription = await getUserSubscription(userId);
    return !subscription.is_vip;
  } catch (error) {
    return true;
  }
};

/**
 * 从localStorage获取用户ID
 * @returns {string|null} 用户ID
 */
export const getCurrentUserId = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      return user.user_id || user.id || null;
    }
    return null;
  } catch (error) {
    return null;
  }
};

/**
 * 试用时长限制（秒）
 */
export const TRIAL_TIME_LIMIT = 3 * 60; // 3分钟 = 180秒
